import styled from 'styled-components';

export const StyledBotonComprobante = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  & > button {
    margin: 0;
    padding: 0;
    border: 0;
    background-color: transparent;
    color: #f42534;
    font-weight: 500;
    cursor: pointer;
    display: flex;
    justify-content: space-around;
    align-items: center;
    & > span {
      margin-right: 0.5rem;
    }
  }
`;

export default StyledBotonComprobante;
